import angular from 'angular';
import geolocation from 'angularjs-geolocation';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import datepicker from 'angular-ui-bootstrap/src/datepicker';
import 'angular-bootstrap-checkbox';

// Dependencies
import servicesModuleName from '../../../../../lib/service';
import geoServiceModule from '../../../../../lib/service/GeoService';
import locationSelectorComponent from '../locationSelector';
import errorListModule from '../../../../../lib/components/errorList';

// Translations
import translate from '../../../../../lib/translation';

// Components
import simpleFieldInstance from '../simpleFieldInstance';

// Controller
import AdhocModalController from './adhocModal.controller';
import template from './adhocModal.html';

const moduleName = 'staff.dashboardScreen.adhocModal';
let module = angular.module(moduleName, [
  servicesModuleName,
  datepickerPopup,
  datepicker,
  geoServiceModule.name,
  uiModal,
  'geolocation',
  translate,
  'ui.checkbox',
  'angularMoment',
  locationSelectorComponent.name,
  simpleFieldInstance.name,
  errorListModule.name,
]);

module.controller('AdhocModalController', AdhocModalController);

module.factory('adhocModal', ['$uibModal', '$q', ($uibModal, $q, date) => {
  return props => {

    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: AdhocModalController,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        $q: () => $q,
        staffUser: props.staffUser
      }
    });
    return modal.result;
  };
}]);

export default module;

